import React, { Component } from "react";
import axios from "../../axios";
import { eraseCookie, setCookie } from "../../function";
import Loader from "../../component/loader/loader";
export default class SigninTAC extends Component {

	clearCoockies = () => {
		/* remove cookie from browser */
		eraseCookie("isTAC");
		eraseCookie("TAC_URL");	
		eraseCookie("threatcop");
		eraseCookie("logo");
		eraseCookie("userType");
		eraseCookie("username");
		eraseCookie("userAgent");
		eraseCookie("firstname");
		eraseCookie("billingType");
		eraseCookie("isDashboard");
		eraseCookie("accessLevel");
		eraseCookie('isTAconnected');
		eraseCookie('isNewClient');
		eraseCookie('isTASyncing');
		eraseCookie('integrationModalOpened');
		eraseCookie('tacEnabled');
		
		/* remove local storate data from browser */
		localStorage["email"] = "";
		localStorage["lastname"] = "";
		localStorage["firstname"] = "";
		localStorage["sessionId"] = "";
		
	};
	componentDidMount() {
		this.clearCoockies();
		this.getUserDetails();
	}

	getUserDetails = async () => {
		try {
			const token = this.props.match.params.token;
			const response = await axios.post(`/api/auth/tac-login`, { token });
			const {
				firstname, lastname, email, threatcop, path, type, userAgent,
				companyName, dashboard, accessLevel, billingType, tacUrl,
				isNewClient, isTAconnected, tacEnabled, devAgent, isDeepFakeEnabled
			} = response.data;

			localStorage.setItem("firstname", firstname);
			localStorage.setItem("lastname", lastname);
			localStorage.setItem("email", email);

			setCookie("threatcop", threatcop, 180);
			setCookie("logo", path, 30000);
			setCookie("userType", type, 30000);
			setCookie("userAgent", userAgent, 30000);
			setCookie("firstname", firstname, 30000);
			setCookie("username", companyName, 30000);
			setCookie("isDashboard", dashboard, 30000);
			setCookie("accessLevel", accessLevel, 30000);
			setCookie("billingType", billingType, 30000);
			setCookie("isTAC", true, 30000);
			setCookie("TAC_URL", tacUrl, 30000);
			setCookie("isNewClient", isNewClient, 30000);
			setCookie("isTAconnected", isTAconnected, 30000);
			setCookie("integrationModalOpened", false, 30000);
			setCookie("tacEnabled", tacEnabled, 30000);
			setCookie("isThreatcopUnleashedClosed", false, 30000);
			setCookie("devAgent", devAgent, 30000);
			setCookie("isDeepFakeEnabled", isDeepFakeEnabled, 30000);

			window.location.href = "/";
		} catch (error) {
			console.error("SSO login failed:", error);
			window.location.href = "/";
		}
	};

	render() {
		return <Loader />;
	}
}
